/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Space, Button, Card, Popconfirm, Layout, Table, Input } from "antd";
import { DELETE_USER, USER } from "../../constants/api";
import LS_SERVICE from "../../utils/localStorage";

function CustomerTable() {
  const { Content } = Layout;
  const navigate = useNavigate();
  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const formattedData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          Name: row.name,
          Email: row.email,
          Phone: row.phone,
          Action: (
            <Space>
              <Button
                onClick={() => {
                  navigate("/customer/edit/" + row.id);
                }}
                block
              >
                Edit
              </Button>
              {LS_SERVICE.get("user_type") === "superAdmin" ? (
                <Popconfirm
                  title="Delete the task"
                  description="Are you sure to delete this task?"
                  onConfirm={() => deleteData(row.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button danger>Delete</Button>
                </Popconfirm>
              ) : null}
            </Space>
          ),
        }));
        setState(formattedData);
        setFilteredState(formattedData);
      } else {
        setState([]);
        setFilteredState([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredState([]);
      setLoading(false);
    };
    getAPI(USER, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = { id: values };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getData();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_USER, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (customer) =>
        customer.Name.toLowerCase().includes(value.toLowerCase()) ||
        customer.Email.toLowerCase().includes(value.toLowerCase()) ||
        customer.Phone.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "Name",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "Email",
      width: 150,
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Manage Customer"
          extra={
            <Space>
              <Input
                placeholder="Search by Name, Email or Phone"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
              />
              <Button onClick={() => navigate("/customer/add")}>
                Add <PlusOutlined />
              </Button>
            </Space>
          }
          bordered
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 240 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default CustomerTable;
